export const userRoles = {
  admin: 'ADM',
  collaborator: 'COLA',
  client: 'CLNT',
  management: 'MGMT',
  physician: 'PHYS',
  sales: 'SLS',
  lisstaff: 'STF',
  guest: 'GST',
  billing: 'BILL'
}

export const userGroups = {
  superAdmins: [
    userRoles.admin, userRoles.management, userRoles.lisstaff
  ],
  allRegistered: [
    userRoles.admin, userRoles.collaborator, userRoles.client, userRoles.management, userRoles.physician, userRoles.sales, userRoles.lisstaff, userRoles.billing
  ],
  guests: [
    userRoles.guest
  ],
  billing: [
    userRoles.billing
  ]
}

export const userPermissions = {
  userEntity: {
    resource: [userRoles.management]
  },
  userInfo: {
    resource: userGroups.allRegistered,
  },
  reqEntity: {
    editRequisitionInformation: [userRoles.admin, userRoles.management, userRoles.lisstaff],
    editPatientInformation: [userRoles.admin, userRoles.management, userRoles.lisstaff, userRoles.collaborator],
    editPatientHistory: [userRoles.admin, userRoles.management, userRoles.lisstaff, userRoles.collaborator],
    downloadSection: [userRoles.admin, userRoles.management, userRoles.lisstaff, userRoles.sales, userRoles.billing],
    show: {
      issues: {
        root: [],
        addIssue: [userRoles.admin, userRoles.management, userRoles.lisstaff]
      },
      reportsDelivery: {
        edit: [userRoles.admin, userRoles.management, userRoles.lisstaff],
        downloadReports: [userRoles.collaborator, userRoles.billing]
      },
    },
    smartFilter: {
      collaboratorField: [
        userRoles.admin,
        userRoles.client,
        userRoles.management,
        userRoles.physician,
        userRoles.lisstaff,
        userRoles.sales,
      ]
    }
  },
  notifications: {
    root: [userRoles.admin, userRoles.management, userRoles.lisstaff, userRoles.collaborator]
  }
}